import { mutationTypes } from '@/core/constants'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	[mutationTypes.ATA.DOCUMENTO.SET_FILTRO_LISTAGEM](state, filtro) {
		state.filtro = filtro
	},

	[mutationTypes.ATA.DOCUMENTO.SET_PAGINACAO_LISTAGEM](state, paginacao) {
		state.paginacao = paginacao
	},

	[mutationTypes.ATA.DOCUMENTO.RESETAR_PAGINA_LISTAGEM](state) {
		state.paginacao.page = 1
	},

	[mutationTypes.ATA.DOCUMENTO.SET_ID_ATA](state, idAta) {
		state.idAta = idAta
	},
	[mutationTypes.ATA.DOCUMENTO.RESETAR_PAGINACAO_LISTAGEM](state) {
		state.paginacao = paginacaoListagem([], 25)
	},
}
